import React from 'react';

const PlayFillSvg = (props) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            fill="#010101"
            d="M7 6v12l12-6z"
        />
    </svg>
);

PlayFillSvg.displayName = 'PlayFillSvg';
export default PlayFillSvg;
